import React, { useMemo } from "react";

interface IProgressBarProps {
    totalProgress: number;
    totalTarget: number;
}

const ProgressBar = (props:IProgressBarProps) => {

    const { totalProgress, totalTarget } = props;

    let progressPercent = 0;
    
    if(totalTarget > 0){
        progressPercent = (totalProgress / totalTarget) * 100;
        progressPercent = Math.min(progressPercent, 100);
    }

    return (
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div 
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progressPercent}%` }}
            ></div>
        </div>
    )
};

export default ProgressBar;
